<template>
    <div id="main">
        <div class="page">
            <div class="alertas vertical-flow">
                <h1 class="title">{{$t('inteligencia-vendas')}}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li><a class="a-inativo">{{$t('settings')}}</a></li>
                        <li><a aria-current="page">{{$t('inteligencia-vendas')}}</a></li>
                    </ul>
                </nav>

                <div class="search-and-filter">
                    <div class="search-bar">
                        <search-bar :onSearch="debouncedOnSearch" />
                    </div>
                </div>

                <div class="alerta-table registry-wrapper">
                    <b-table
                        v-if="!first"
                        :data="allAlertas"
                        :mobile-cards="false"
                        class="data-table"
                    >
                            <b-table-column 
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'empresa'">
                                    <router-link :to="{name : 'edit-alerta', params: { idempresa : props.row.id, rsocial: props.row.rsocial }}">
                                        {{ props.row.rsocial }}
                                    </router-link>
                                </div>
                            </b-table-column>
                        <template slot="empty">
                            <section class="section is-flex empty-table">
                                <div class="content has-text-grey has-text-centered">
                                    <span class="has-text-weight-bold">{{$t('msg-alertas-empty-table')}}</span>
                                </div>
                            </section>
                        </template>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FiltroRelatorioService from "@/services/FiltroRelatorioService";

export default {
    data() {
        return {
            first: true,
            allAlertas: [],
            service: new FiltroRelatorioService(this.$http, this.$router),
            fields: [
                {key: 'empresa', width: null, sortable: true, sortFn: null}
            ],
            queryFilter : '',
            deleteThis: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10,25,50,100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1
            },
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 750)
        this.permissao = this.hasPermissionAccess("admin", "inteligencia-vendas", "alertas");
        if ( !this.permissao.read){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'inteligencia-vendas' }
            });
        } else {
            
            this.carregarDados();
        }
    },
    methods: {
        updatePagination(value){
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados (currentPage = 1) {
            if(currentPage==1&&this.pagination.currentPage!=1)this.pagination.resetPagination=true;
            this.$store.commit('addLoader');
            this.service
                .findAllEmpresa(currentPage - 1, this.pagination.perPage, this.queryFilter)
                .then(r => {
                    if (r.status != 200) {
                        console.error(`Erro ${r.status} ao carregar alertas.`, r.message);
                        this.$root.showMessage("error", 'msg-erro-alertas-load');
                    } else {
                        this.allAlertas = r.content;
                        this.pagination.totalRows = r.totalElements;
                    }
                })
                .catch(e => {
                    console.error('Erro ao carregar alertas', e);
                    this.$root.showMessage("error", 'msg-erro-alertas-load');
                })
                .finally(() => {
                    this.pagination.resetPagination = false;
                    this.$store.commit('removeLoader');
                    if (this.first) {
                        this.first = false;
                    }
                });
        },
        onSearch (value) {
            this.queryFilter = value;
            this.carregarDados();
        }
    }
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
}

.page {
    position: relative;
    padding-left: 0;
}

.alertas .search-and-filter {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 20px;
}

.alertas .search-and-filter .search-bar {
    width: 100%;
}

.alertas .search-and-filter .filter-bar {
    width: 31%;
}
</style>